module.exports = __webpack_public_path__ + "img/crane-cursor.aed01704.png";